var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 98,
    viewBox: "0 0 50 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55445 1.68104C-0.55582 3.88289 -0.511959 7.40819 1.65242 9.555L37.4008 45.0132C39.604 47.1985 39.604 50.8015 37.4008 52.9868L1.65242 88.445C-0.511959 90.5918 -0.55582 94.1171 1.55445 96.319C3.66472 98.5208 7.13001 98.5654 9.2944 96.4186L45.0427 60.9605C51.6524 54.4044 51.6524 43.5956 45.0427 37.0396L9.2944 1.58137C7.13001 -0.565447 3.66472 -0.520823 1.55445 1.68104Z",
    fill: "#0D41E1",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselNext);
export default __webpack_public_path__ + "static/media/carouselNext.3e7cb1cfde6673955fb94773b265d7cb.svg";
export { ForwardRef as ReactComponent };